'use strict';
const { createAddQueries } = require('../addQueries');
const {
  id,
  payerId,
  userId,
  scheduledTransactionId,
} = require('./commons');

module.exports = createAddQueries({
  returnModel: {
    name: 'userSchedTran',
  },
  finders: [
    id,
    payerId,
    userId,
    scheduledTransactionId,
  ],
  orderBy: [
    id,
    payerId,
    userId,
    scheduledTransactionId,
  ],
});
